import { Directive, OnDestroy, OnInit, input } from '@angular/core';

import { JackpotRibbonComponent } from './jackpot-ribbon.component';
import { JackpotValueModel } from './jackpot-value.model';

const __DEFAULT_TICK_INTERVAL__ = 1500;
const __DEFAULT_INCREMENT_MULTIPLIER__ = 0.01;
const __DEFAULT_TICK_INCREMENT__ = 1;

@Directive({
    selector: '[csWithJPIncrementalTicking]',
    standalone: true,
})
export class JackpotValueIncrementalTickingDirective implements OnInit, OnDestroy {
    withIncrementalTick = input<boolean>(true);
    tickIncrement = input<number>(__DEFAULT_TICK_INCREMENT__);
    incrementMultiplier = input<number>(__DEFAULT_INCREMENT_MULTIPLIER__);
    tickInterval = input<number>(__DEFAULT_TICK_INTERVAL__);
    currencyOnRight = input<boolean>(false);

    scheduledTickInterval: any;

    constructor(private readonly ribbonComponent: JackpotRibbonComponent) {}

    ngOnDestroy(): void {
        clearInterval(this.scheduledTickInterval);
    }

    ngOnInit(): void {
        if (this.withIncrementalTick()) {
            clearInterval(this.scheduledTickInterval);
            this.scheduledTickInterval = setInterval(() => {
                const currVal = this.incrementJackpotValue(this.ribbonComponent.currentValue());
                this.ribbonComponent.currentValue = currVal;
            }, this.tickInterval());
        }
    }

    private incrementJackpotValue(currentValue: JackpotValueModel | undefined) {
        const tickIncrMultiplier = 0.01;
        if (!currentValue) {
            return;
        }

        const { currency, amount } = currentValue;
        let newAmount = amount + this.tickIncrement() * tickIncrMultiplier;
        return { currency, amount: newAmount };
    }
}
